import styled, { css } from 'styled-components';

export const Card = styled.div(
  ({ theme }) => css`
    background-color: ${theme.co.primary95};
    border: ${theme.bo.mediumWidth} solid ${theme.co.primary50};
    border-radius: ${theme.bo.mediumLarge};
    padding: ${theme.sz.s4};
    position: relative;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: stretch;
    margin: ${theme.sz.s2} 0;

    svg {
      position: absolute;
      right: ${theme.sz.s4};
      width: 70%;
      color: ${theme.co.primary60};
      opacity: 0.35;
    }
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    z-index: 1;
    gap: ${theme.sz.s3};
    align-items: flex-start;
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxs};
    color: ${theme.co.neutral10};
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    color: ${theme.co.neutral20};
  `,
);

export const IconDecoration = styled.div(
  ({ theme }) => css`
    min-width: ${theme.sz.s16};

    svg {
      width: ${theme.sz.s12};
      height: ${theme.sz.s12};
      color: ${theme.co.neutral0};
      opacity: 1;
    }
  `,
);
